import { createAction } from '@ngrx/store';

/**
 * Actions dispatched to retrieve recommended products
 */
export const getDailyAllowanceRecommendation = createAction('[Daily Allowance] Get Recommendation');
